module.exports = __webpack_public_path__ + "static/img/logo.4bf4b5ce.jpg";